import React from "react";
import {Controller} from "react-hook-form";
import {FormControlLabel, Radio} from "@mui/material";

export const RadioMain = ({
                              control,
                              name,
                              rules,
                              label,
                              value,
                              styles,
                              onClick,
                              disabled,
                              labelPlacement = 'start'
                          }) => {
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({field}) => {
                return (
                    <FormControlLabel
                        {...field}
                        className='radio-main-form-control'
                        disabled={disabled}
                        onChange={(e) => field.onChange(e.target.value)}
                        control={
                            <Radio
                                onClick={onClick}
                                checked={field.value === value}
                                sx={{
                                    color: styles?.color || '#DFE5EB',
                                    "&.Mui-checked": {
                                        color: styles?.checkedColor || '#FFC107',
                                    },
                                }}
                            />
                        }
                        label={label}
                        value={value}
                        labelPlacement={labelPlacement}
                    />
                );
            }}
        />
    );
};
